// データ・補助 API の基底パス。
// 公開 symlink (/GPV) へのハードコード依存を廃止し、アプリ設置ディレクトリ相対に統一する。
// - 本番: アプリのディレクトリに dat symlink と get_Wind.php を配置する (GPV-1.x と同じ構成)。
// - 開発: webpack devServer が dat / get_Wind.php を本番サーバーへ proxy する (webpack.config.js)。
const BASE = ".";

export function resourcePath(path: string) {
    return `${BASE}/${path}`;
}

export function dataPath(path: string) {
    return resourcePath(`dat/${path}`);
}
